<div class="app-isf-ocr-quick-fix-buyer-details">
  <div class="app-isf-ocr-quick-fix-buyer-details__header">
    <div class="app-isf-ocr-quick-fix-buyer-details__header__left">
      <p class="app-isf-ocr-quick-fix-buyer-details__header__title">
        {{ "ENTITY.BUYER" | translate | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'INFO.BY.SUB_TITLE' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <div class="app-isf-ocr-quick-fix-buyer-details__row">
    <p class="app-isf-ocr-quick-fix-buyer-details__text m-0">
      {{ "INFO.BY.SUB_TITLE" | translate }}
    </p>
    <p class="app-isf-ocr-quick-fix-buyer-details__hint-text">{{ "LABELS.USE_PREV_INFO" | translate }}</p>
  </div>

  <ng-container *ngIf="isEditMode">
    <div *ngFor="let isfEntity of possibleIsfEntities; let inx = index" class="app-isf-ocr-quick-fix-buyer-details__row">
      <app-entity-unify-card
        [entity]="isfEntity"
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.BUYER"
        [selectedValueControl]="formGroup.get('id')"
        [labelOverride]="getEntityOverrideLabel(isfEntity)"
        [isDesktop]="isDesktop"
      ></app-entity-unify-card>
    </div>
  </ng-container>

  <div class="app-isf-ocr-quick-fix-buyer-details__row">
    <app-section-form-block-layout
      *ngIf="!!buyerFields"
      [formGroup]="formGroup"
      [editBlockDescription]="(!!importer || !!consignee) && isEditMode ? 'LABELS.OR_ADD_DETAILS' : ''"
      [fields]="buyerFields"
      [displayFields]="buyerDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(buyerFields, formGroup)"
      [isHideBorder]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <identifier-entity-update
        edit-block-header
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.BUYER"
        [type]="enumEntityType.buyer"
        [errors]="formErrors"
        [identifierFieldName]="'entityIdentifier'"
        [identifierQualifierFieldName]="'entityIdentifierQualifier'"
        [needUpdateValidators]="true"
      ></identifier-entity-update>
      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.BUYER"
        [errors]="formErrors"
        [isShowState]="true"
        [isShowCountry]="true"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-isf-ocr-quick-fix-buyer-details__hr" />

    <div class="app-isf-ocr-quick-fix-buyer-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
